import { MenuItem, MenuItemProps } from '@mui/material';
import { styled } from '@mui/system';

export const SectionLabel = styled('li')(({ theme }) => ({
  '&:first-of-type': {
    marginTop: theme.spacing(1),
  },
  listStyle: 'none',
  margin: `${theme.spacing(2)} ${theme.spacing(1)} 0`,
  padding: `0 ${theme.spacing(1)} ${theme.spacing(0.5)}`,
}));

export const SectionLabelText = styled('span')(({ theme }) => ({
  color: theme.palette.text.secondary,
  display: 'block',
  fontSize: '11px',
  fontWeight: 600,
  letterSpacing: '0.06em',
  lineHeight: 1.5,
  textTransform: 'uppercase',
}));

export const StyledMenuItem = styled(MenuItem)<
  MenuItemProps & { component?: React.ElementType; href?: string }
>(({ theme }) => ({
  '&:hover': {
    backgroundColor: 'transparent',
  },
  '&:hover .menu-item-content': {
    backgroundColor: theme.palette.action.hover,
  },
  '&.Mui-selected': {
    '&:hover': {
      backgroundColor: 'transparent',
    },
    '&:hover .menu-item-content': {
      backgroundColor: `${theme.palette.primary.main}14`,
    },
    backgroundColor: 'transparent',
  },
  '&.Mui-selected .menu-item-content': {
    backgroundColor: `${theme.palette.primary.main}0D`,
    color: theme.palette.primary.main,
  },
  backgroundColor: 'transparent',
  color: 'inherit',
  margin: '1px 4px 1px 0',
  paddingLeft: '8px',
  paddingRight: '8px',
  textDecoration: 'none',
}));

export const MenuItemContent = styled('span')(({ theme }) => ({
  alignItems: 'center',
  borderRadius: theme.shape.borderRadius,
  display: 'inline-flex',
  gap: theme.spacing(1),
  padding: `${theme.spacing(0.5)} ${theme.spacing(1.5)}`,
  transition: 'background-color 150ms ease',
}));

export const StyledMainMenuItem = styled('li')(({ theme }) => ({
  marginLeft: theme.spacing(2),
}));
